import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import CategoryCards from './components/CategoryCards';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '91叔叔',
    url: 'https://www.91uncle.com/',
    description: '91叔叔是深受用户喜爱的内容平台，为您提供优质内容、实用资源与精彩体验',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.91uncle.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '91叔叔',
    url: 'https://www.91uncle.com/',
    description: '91叔叔是深受用户喜爱的内容平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-9191',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <HeroSection />
      <StatsSection />
      <CategoryCards />
      <FeaturedArticles />
      <LatestArticles />
      <FaqSection />
      <CtaSection />
    </>
  );
}